"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const auth0_token_manager_1 = __importDefault(require("@digitools/auth0-token-manager"));
const react_router_dom_1 = require("react-router-dom");
const LoadingScreen_1 = __importDefault(require("../components/LoadingScreen/LoadingScreen"));
const AuthContext_1 = __importDefault(require("../contexts/AuthContext"));
const EnvUtils_1 = require("../utils/EnvUtils");
const useUserApi_1 = __importStar(require("../hooks/useUserApi"));
const audience = (0, EnvUtils_1.getEnvVariable)('auth0Audience');
const clientID = (0, EnvUtils_1.getEnvVariable)('auth0ClientId');
const domain = (0, EnvUtils_1.getEnvVariable)('auth0Domain');
const auth0RedirectUri = (0, EnvUtils_1.getEnvVariable)('auth0RedirectUri');
const auth0UserMetadataUrl = (0, EnvUtils_1.getEnvVariable)('auth0UserMetadataUrl');
const Auth0Provider = ({ children, redirectUri = auth0RedirectUri, redirectPathname = '/callback', successFallbackUrl = '/', }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const { getMyProfile } = (0, useUserApi_1.default)();
    const [tokenManager, setTokenManager] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [user, setUser] = (0, react_1.useState)();
    const [authHeader, setAuthHeader] = (0, react_1.useState)('');
    const init = async () => {
        setIsLoading(true);
        const newTokenManager = await auth0_token_manager_1.default.init({
            audience,
            clientID,
            domain,
            redirectUri,
            scope: 'openId profile email',
        });
        let parseHashFailed = false;
        if (location.pathname === redirectPathname && !!location.hash) {
            try {
                await newTokenManager.handleAuthentication();
            }
            catch (_) {
                parseHashFailed = true;
                // need a window assign here, as we are redirecting across apps
                window.location.assign('/public/unauthorized');
            }
        }
        if (newTokenManager.isAuthenticated()) {
            try {
                const redirectUrl = sessionStorage.getItem('redirectUri');
                const idToken = await newTokenManager.getProfile();
                const newAuthHeader = await newTokenManager.getAuthHeader();
                const profile = idToken[auth0UserMetadataUrl];
                // augment profile with applicationPermissions because it is no longer on the idToken
                const userData = (await getMyProfile(newAuthHeader)).data;
                profile.applicationPermissions = userData.userMetadata.internalUserPermission.internalApplicationPermissions;
                const loginTimestamp = idToken.auth_time * 1000;
                try {
                    await (0, useUserApi_1.updateUserLastLogin)(newTokenManager.getAuthHeader(), profile.loginId, {
                        lastLogin: new Date(loginTimestamp).toISOString().replace('T', ' '),
                    });
                }
                catch (e) {
                    console.error(e, `Failed to update Internal User Last Login for ${profile.loginId}`);
                }
                if (!!redirectUrl) {
                    history.push(redirectUrl);
                }
                else {
                    history.push(successFallbackUrl);
                }
                sessionStorage.removeItem('redirectUrl');
                setUser(profile);
                setAuthHeader(newAuthHeader);
                setTokenManager(newTokenManager);
                setIsLoading(false);
            }
            catch (_) {
                // If something goes wrong here, they likely have an active Auth0 session with
                // the external app, but not the internal app.
                sessionStorage.setItem('redirectUrl', location.pathname);
                // TODO: Need to update authorize options interface to be aware of prompt
                // @ts-ignore
                newTokenManager.authorize({ connection: 'lfg-adfs', prompt: 'login' });
            }
        }
        if (!newTokenManager.isAuthenticated() && !parseHashFailed) {
            sessionStorage.setItem('redirectUrl', location.pathname);
            // TODO: Need to update authorize options interface to be aware of prompt
            // @ts-ignore
            newTokenManager.authorize({ connection: 'lfg-adfs', prompt: 'login' });
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        init();
    }, []);
    const value = {
        isLoading,
        user,
        authHeader,
    };
    return ((0, jsx_runtime_1.jsxs)(AuthContext_1.default.Provider, { value: value, children: [isLoading && (0, jsx_runtime_1.jsx)(LoadingScreen_1.default, {}), !isLoading && children] }));
};
exports.default = Auth0Provider;
